import { Colors, ColorsType } from '@common/tokens';

const LIGHT_BACKGROUND_THRESHOLD = 150;

export function getReadableTextColor(color: ColorsType): ColorsType {
  const isLightBackground =
    getPerceivedLuminance(Colors[color]) > LIGHT_BACKGROUND_THRESHOLD;

  return isLightBackground ? 'midnightDarker' : 'white';
}

const BORDER_CONTRAST_RATIO = 0.15;

export function getChipBorderColor(color: ColorsType): string {
  const hexColor = Colors[color];
  const isLightBackground =
    getPerceivedLuminance(hexColor) > LIGHT_BACKGROUND_THRESHOLD;
  const mixTarget = isLightBackground ? 0 : 255;

  const channels = parseRgbChannels(hexColor).map((channel) =>
    Math.round(channel + (mixTarget - channel) * BORDER_CONTRAST_RATIO)
  );

  return `#${channels
    .map((channel) => channel.toString(16).padStart(2, '0'))
    .join('')}`;
}

function getPerceivedLuminance(hexColor: string): number {
  const [red, green, blue] = parseRgbChannels(hexColor);

  return 0.299 * red + 0.587 * green + 0.114 * blue;
}

function parseRgbChannels(hexColor: string): number[] {
  const hex = expandShorthandHex(hexColor.replace('#', ''));

  return [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16));
}

function expandShorthandHex(hex: string): string {
  if (hex.length !== 3) return hex;

  return hex
    .split('')
    .map((char) => char + char)
    .join('');
}
